// React
import React, { FC } from 'react';

// Containers
import { ContentPerformanceOverview } from 'Containers/GoodData/dashboards';

interface Props {
  moduleAccess: any;
}

const ContentPerformance: FC<Props> = (props: Props) => {
  const { moduleAccess } = props;
  return <ContentPerformanceOverview moduleAccess={moduleAccess} />;
};

export default ContentPerformance;
try {
    // @ts-ignore
    ContentPerformance.displayName = "ContentPerformance";
    // @ts-ignore
    ContentPerformance.__docgenInfo = { "description": "", "displayName": "ContentPerformance", "props": { "moduleAccess": { "defaultValue": null, "description": "", "name": "moduleAccess", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/pages/Analytics/ContentPerformance/ContentPerformance.tsx#ContentPerformance"] = { docgenInfo: ContentPerformance.__docgenInfo, name: "ContentPerformance", path: "src/pages/Analytics/ContentPerformance/ContentPerformance.tsx#ContentPerformance" };
}
catch (__react_docgen_typescript_loader_error) { }